import axios from 'axios'

export default new class TestJobsService {
  get (testJobId) {
    return axios.get('/test-jobs/' + testJobId)
  }

  getList (projectId) {
    return axios.get('/test-jobs?projectId=' + projectId)
  }

  new (data) {
    return axios.post('/test-jobs',data)
  }

  update (testJobId, data) {
    return axios.put('/test-jobs/' + testJobId ,data)
  }

  delete (testJobId) {
    return axios.delete('/test-jobs/' + testJobId)
  }
}()
